import styled from 'styled-components';

const TotalItem = styled.div`
  display: flex;
  justify-content: space-between;
`;

export default TotalItem;
